<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
          <HelperNav />
          <div class="dashboard-wrapper">

            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  سبد دارایی شما 
                  <div class="mdi mdi-information-outline"></div>
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

                <h3>دارایی شما در این لحظه</h3>
                <div class="property-box">
                <div class="property-box-item">
                  <h3>تومان</h3>
                  <h1>{{formatPrice(userData.user_detail.cash)}}</h1>
                  <div class="convert" @click="convert = {} , convert_cash = true">تبدیل به تتر</div>
                </div>
                <div class="property-box-item">
                  <h3>تتر</h3>
                  <h1>{{userData.user_detail.tether}}</h1>
                  <div class="convert" @click="convert = {} , convert_tether = true">تبدیل به تومان</div>
                </div>
                </div>

                <div v-if="userData.user_detail.user_status !== 2" class="operations">
                  <div class="operate deposit disabled">
                    <h2>واریز</h2>
                  </div>
                  <div class="operate harvest disabled">
                    <h2>برداشت</h2>
                  </div>
                </div>

                <div v-if="userData.user_detail.user_status == 2" class="operations">

                  <div class="operations-item">
                    <router-link v-if="state_setting.allow_deposit" :to="{name:'Deposit'}" class="operate">
                        <div style="height:100%;" class="dashboard-bg-image">
                          <h2>واریز <i class="mdi mdi-information-outline"></i></h2>
                        </div>
                    </router-link>
                    <div v-else class="operate disabled">
                      <h2>واریز</h2>
                    </div>
                  </div>

                  <div class="operations-item">
                    <router-link v-if="state_setting.allow_harvest" :to="{name:'Withdraw'}" class="operate">
                        <div style="height:100%;" class="dashboard-bg-image">
                          <h2>برداشت <i class="mdi mdi-information-outline"></i></h2>
                        </div>
                    </router-link>
                    <div v-else class="operate disabled">
                      <h2>برداشت</h2>
                    </div>
                  </div>
                  
                </div>

                <!-- 
                <div class="dashboard-chart-wrapper large">
                  <div class="title-wrapper">
                    <p class="title">تغییرات کیف پول شما در 30 روز گذشته</p>

                    <div class="filters">
                      <div @click="changeChartData('rial')" :class="[defaultChart == 'تومان' ? 'active' : '' ]" class="filter">تومان</div>
                      <div @click="changeChartData('tether')" :class="[defaultChart == 'تتر' ? 'active' : '' ]" class="filter">تتر</div>
                    </div>
                    
                  </div>
                  <div v-if="chartDataLoaded" class="dashboard-chart-inner">
                    <apexchart v-if="defaultChart == 'تومان'" height="100%" width="100%" type="area" :options="cash.options" :series="cash.series"></apexchart>
                    <apexchart v-if="defaultChart == 'تتر'" height="100%" width="100%" type="area" :options="tether.options" :series="tether.series"></apexchart>
                  </div>
                </div> -->

                <!-- <template v-if="tetherRateDateLoaded">
                  <div class="convertor-chart">
                    <div class="dashboard-chart-wrapper convertor">
                      <div class="title-wrapper">
                        <p class="title">
                          <img class="symbol-image" :src="this.StaticImageUrl+'assets/images/tether-png.png'" alt="">
                          نرخ خرید تتر از ارزینه
                        </p>
                          <span class="float-left">{{ this.formatPrice(state_prices.sale_price) }} تومان</span>
                      </div>
                      <div class="dashboard-chart-inner">
                        <apexchart height="100%" width="100%" type="area" :options="sale_tether_rate.options" :series="sale_tether_rate.series"></apexchart>
                      </div>
                    </div>
                  </div>

                  <div class="convertor-chart">
                    <div class="dashboard-chart-wrapper convertor">
                      <div class="title-wrapper">
                        <p class="title">
                          <img class="symbol-image" :src="this.StaticImageUrl+'assets/images/tether-png.png'" alt="">
                          نرخ فروش تتر به ارزینه
                        </p>
                          <span class="float-left">{{ this.formatPrice(state_prices.buy_price) }} تومان</span>
                      </div>
                      <div class="dashboard-chart-inner">
                        <apexchart height="100%" width="100%" type="area" :options="buy_tether_rate.options" :series="buy_tether_rate.series"></apexchart>
                      </div>
                    </div>
                  </div>
                </template> -->

              </div>
            </div>

          </div>

          <modal @close="alert_modal = false" :open="alert_modal" :maxWitdh="'600px'">
            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  هشدار 
                </div>
                <span>
                  <i @click="alert_modal = false" class="mdi mdi-close"></i>
                </span>
              </div>
              <div class="ar-card-body text-right">

                <img :src="StaticImageUrl+'assets/images/Warning-rafiki.svg'" alt="" style="width:230px;margin:auto">

                <div v-if="userData.user_detail.user_status == 0" class="text-center">
                  کاربر گرامی, شما احراز هویت نشده اید. برخی خدمات ارزینه برای شما محدود شده است.
                </div>
                <div v-if="userData.user_detail.user_status == 1" class="text-center">
                  کاربر گرامی, درخواست احراز هویت شما در دست بررسی است.
                </div>
                <div v-if="userData.user_detail.user_status == 3" class="text-center">
                  کاربر گرامی, درخواست احراز هویت شما رد شده است.
                  <div v-if="userData.user_detail.reject_reason">
                    علت رد : {{ userData.user_detail.reject_reason }}
                  </div>
                </div>
                
                <div class="text-center" v-if="userData.user_detail.user_status == 0">
                  <router-link :to="{name:'Authentication'}" class="ar-btn size-md danger">احراز هویت</router-link>
                </div>
                <div class="text-center" v-if="userData.user_detail.user_status == 1">
                  <button class="ar-btn size-md danger" @click="alert_modal = false">متوجه شدم</button>
                </div>
                <div class="text-center" v-if="userData.user_detail.user_status == 3">
                  <router-link :to="{name:'Authentication'}" class="ar-btn size-md danger">احراز هویت</router-link>
                </div>

              </div>
            </div>
          </modal>

          <modal @close="convert_cash = false" :open="convert_cash" :maxWitdh="'600px'">
      
            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  تبدیل دارایی تومانی به تتر 
                </div>
                <span>
                  <i @click="convert_cash = false" class="mdi mdi-close"></i>
                </span>
              </div>
              <div class="ar-card-body text-right text-primary-dark">

                <h4 class="my-3 text-center">
                  مقدار قابل تبدیل: {{formatPrice(userData.user_detail.cash)}} تومان
                </h4>
                
                <div class="ar-form-group">
                  <label>مقدار تبدیل</label>
                  <input onclick="this.select()" class="ar-form-control text-center" type="number" @keypress="just_float($event)" @input="changedPaidAmount(true)" v-model="convert.paid_amount">
                  <small v-if="convert.paid_amount">معادل {{formatPrice(convert.paid_amount)}} تومان</small>
                  <div v-if="errors.paid_amount" class="ar-form-text">
                    <small>{{ errors.paid_amount[0] }}</small>
                  </div>
                </div>

                <h4 class="my-3 text-center">
                  نرخ تبدیل: {{ state_prices.sale_price }}
                </h4>
                
                <div class="ar-form-group">
                  <label>مقدار محاسبه شده</label>
                  <input disabled class="ar-form-control text-center" v-model="convert.received_amount">
                </div>

                <small>کارمزد کلیه تبدیل ها صفر و در همان لحظه قابل برداشت می باشد.</small>
                
              </div>
              <div class="ar-card-footer">
                <button @click="Convert('cash')" class="ar-btn size-sm primary">ثبت</button>
                <button @click="convert_cash = false" class="ar-btn size-sm outline-primary mx-3">انصراف</button>
              </div>
            </div>

          </modal>

          <modal @close="convert_tether = false" :open="convert_tether" :maxWitdh="'600px'">
      
            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  تبدیل دارایی تتری به تومان 
                </div>
                <span>
                  <i @click="convert_tether = false" class="mdi mdi-close"></i>
                </span>
              </div>
              <div class="ar-card-body text-right text-primary-dark">

                <h4 class="my-3 text-center">
                  مقدار قابل تبدیل: {{userData.user_detail.tether}} تتر
                </h4>
                
                <div class="ar-form-group">
                  <label>مقدار تبدیل</label>
                  <input onclick="this.select()" class="ar-form-control text-center" type="number" @keypress="just_float($event)" @input="changedPaidAmount(false)" v-model="convert.paid_amount">
                  <div v-if="errors.paid_amount" class="ar-form-text">
                    <small>{{ errors.paid_amount[0] }}</small>
                  </div>
                </div>

                <h4 class="my-3 text-center">
                  نرخ تبدیل: {{ state_prices.buy_price }}
                </h4>
                
                <div class="ar-form-group">
                  <label>مقدار محاسبه شده</label>
                  <input disabled class="ar-form-control text-center" v-model="convert.received_amount">
                  <small v-if="convert.received_amount">معادل {{formatPrice(convert.received_amount)}} تومان</small>
                </div>

                <small>کارمزد کلیه تبدیل ها صفر و در همان لحظه قابل برداشت می باشد.</small>
                
              </div>
              <div class="ar-card-footer">
                <button @click="Convert('tether')" class="ar-btn size-sm primary">ثبت</button>
                <button @click="convert_tether = false" class="ar-btn size-sm outline-primary mx-3">انصراف</button>
              </div>
            </div>

          </modal>

        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
import Modal from '../../components/Modal.vue'
export default {
  name: 'Dashboard',
  components:{
    Sidebar,
    Header,
    HelperNav,
    Modal
  },
  data : () => ({
    alert_modal:false,
    chartDataLoaded:false,
    user_crypto_list:{},
    defaultChart:'تومان',
    convert_cash : false,
    convert_tether : false,
    convert:{},
    errors:{},
    cash:{
      options: {
        chart: {
          id: 'vuechart-example',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis:{
          labels: {
            show: false,
          }
        },
        colors:['#003b6d'],
      },
      series: [
        {
          name: 'تومان',
          data: []
        }
      ],
    },
    tether:{
      options: {
        chart: {
          id: 'vuechart-example',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis:{
          labels: {
            show: false,
          }
        },
        colors:['#003b6d'],
      },
      series: [
        {
          name: 'تومان',
          data: []
        }
      ],
    },
    data:{
      tether:{},
      cash:{},
    },
    tetherRateDateLoaded:false,
    buy_tether_rate:{
      options: {
        chart: {
          id: 'vuechart-example',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            rotateAlways: true,
                offsetY: 0,
                offsetX: 0,
            hideOverlappingLabels: false,
          }
        },
        colors:['#003b6d'],
      },
      series: [{
        name: 'نرخ فروش ارزینه',
        data: [2, 4, 5, 2, 8, 4, 9, 2 , 5, 8, 4, 9, 2 , 5]
      }],
    },
    sale_tether_rate:{
      options: {
        chart: {
          id: 'vuechart-example',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            rotateAlways: true,
                offsetY: 0,
                offsetX: 0,
            hideOverlappingLabels: true,
          }
        },
        colors:['#003b6d'],
      },
      series: [{
        name: 'نرخ فروش ارزینه',
        data: [2, 4, 5, 2, 8, 4, 9, 2 , 5, 8, 4, 9, 2 , 5]
      }],
    },
  }),
  watch:{
    $route (to, from){
      
      const status = this.userData.user_detail.user_status;
      if(Number.isInteger(status))
      {
        if(status !== 2){
          this.alert_modal = true
        }
      }

    }
  },
  methods:{
    changedPaidAmount(status){
      const c = this.convert;
      if(status){
        var calc = parseFloat(c.paid_amount / this.state_prices.sale_price)
        c.received_amount = calc.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      }else{
        c.received_amount = parseInt(c.paid_amount * this.state_prices.buy_price)
      }
    },
    DashboardDetails () {
      const api_token = this.getToken()
      this.$axios.get(`DashboardDetails`,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        // this.options.xaxis.categories = res.data.data.labels
        this.cash.series[0].data = res.data.data.cash_chart
        this.tether.series[0].data = res.data.data.tether_chart
        this.chartDataLoaded = true
      })
      .catch(err => {
      });
    },
    changeChartData(type){
      this.chartDataLoaded = false
      if(type == 'rial'){
        this.defaultChart = 'تومان';
        this.chartDataLoaded = true
      }else{
        this.defaultChart = 'تتر';
        this.chartDataLoaded = true
      }
    },
    tetherChartsData () {
      this.$axios.get(`tetherChartsData`)
      .then(res => {
        this.buy_tether_rate.options.xaxis.categories = res.data.data.buy.rate_date
        this.buy_tether_rate.series[0].data = res.data.data.buy.rates
        this.sale_tether_rate.options.xaxis.categories = res.data.data.sale.rate_date
        this.sale_tether_rate.series[0].data = res.data.data.sale.rates

        this.tetherRateDateLoaded = true
      })
      .catch(err => {
      });
    },
    Convert(type){
      this.errors = {}
      this.activeLoading(true)
      const api_token = this.getToken()

      this.convert.type = type
      this.$axios.post(`submitConvertReq` , this.convert,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( res => {
        this.activeLoading(false)
        this.convert = {}
        this.convert_cash = false
        this.convert_tether = false
        this.authUser(res.data.data)
        this.$notify({
          group: 'foo',
          type: 'success',
          duration: 5000,
          text: res.data.message
        });
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });
    }
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()

    const status = this.userData.user_detail.user_status;
    if(Number.isInteger(status))
    {
      if(status !== 2){
        this.alert_modal = true
      }
    }
    
  }
}
</script>
<style>
.cryptos-inner{
  display: flex;
  align-items: center;
  color: #fff;
  background: var(--theme);
  border-radius: 12px;
  padding: 8px;
}
.cryptos-inner div{
  width: 33.33%;
}
.cryptos-inner .logo img{
  height: 60px;
}
.cryptos-inner .name{
  text-align: center;
}
.cryptos-inner .amount{
  text-align: left;
}
</style>